module.exports = __webpack_public_path__ + "static/media/kirk_min.17313ea5.png";